"use strict";

var base = require("./storeLocator/storeLocator");
var shippingHelpers = require("./checkout/shipping");

// Toggle Button See More Stores
function toggleSeeMoreButton() {
    if ($("#postalCodeSearchInputPickIt").val() > 0) {
        $(".see-all-stores-pickit").addClass("shown-button");
    } else {
        $(".see-all-stores-pickit").removeClass("shown-button");
    }
}

/**
 * Uses google maps api to render a map in pickIt
 */
function maps() {
    var map;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(-34.604713, -58.43429);
    var mapOptions = {
        scrollwheel: false,
        zoom: 10,
        center: latlng,
    };

    map = new google.maps.Map($("#map-canvas-pickit")[0], mapOptions);
    var mapdiv = $("#map-canvas-pickit").attr("data-locations");
    if (mapdiv != "null") {
        mapdiv = JSON.parse(mapdiv);
        var bounds = new google.maps.LatLngBounds();

        // Customized google map marker icon with svg format
        var markerImg = {
            path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
            fillColor: "#e60c19",
            fillOpacity: 1,
            scale: 1,
            strokeColor: "white",
            strokeWeight: 0.8,
            anchor: new google.maps.Point(0, 0),
            labelOrigin: new google.maps.Point(0, -30),
        };

        var mapdivKeys = Object.keys(mapdiv);
        var filteredForVisualRenderInMap = false;

        mapdivKeys.forEach(function (key) {
            var item = mapdiv[key];
            if (item.filteredForVisualRenderInMap) {
                filteredForVisualRenderInMap = true;
            }
        });

        mapdivKeys.forEach(function (key) {
            var item = mapdiv[key];
            var storeLocation = new google.maps.LatLng(
                item.latitude,
                item.longitude
            );

            var marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: markerImg,
                label: {
                    text: item.storeId.toString(),
                    color: "white",
                    fontSize: "10px",
                },
            });

            marker.addListener("click", function () {
                infowindow.setOptions({
                    content: item.infoWindowHtml,
                });
                infowindow.open(map, marker);
                let selectRadioButton = $(`#input-${item.storeId}-pickit`);
                let selectStoreButton = $(".select-store-pickit");
                var resultsContainer =
                    selectRadioButton.closest(".results-pickit");
                $('input[name="store"]').attr("checked", false);
                var cardBodyContainer =
                    selectRadioButton.closest(".form-check");
                var scrollTo =
                    cardBodyContainer.position().top +
                    resultsContainer.scrollTop();
                resultsContainer.animate(
                    {
                        scrollTop: scrollTo,
                    },
                    300
                );
                selectStoreButton.attr("disabled", false);
                selectRadioButton.attr("checked", true);
            });

            // Create a minimum bound based on a set of storeLocations
            // This bounding box can be used to ensure that all specified points are visible within a map's viewport. .
            // Each marker is included in the bound, so all are going to be displayed
            if (!filteredForVisualRenderInMap) {
                bounds.extend(marker.position);
            } else if (item.filteredForVisualRenderInMap) {
                bounds.extend(marker.position);
            }
        });
        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        if (mapdiv && mapdiv.length !== 0) {
            map.fitBounds(bounds);
        }
    }
}

/**
 * Renders the results of the search and updates the pickIt map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $(".results-pickit");
    var $mapDiv = $("#map-canvas-pickit");
    if (data.stores) {
        var hasResults = data.stores.length > 0;
        if (!hasResults) {
            $(".store-locator-no-results-pickit").removeClass("d-none");
        } else {
            $(".store-locator-no-results-pickit").addClass("d-none");
        }
        $resultsDiv
            .empty()
            .data("has-results", hasResults)
            .data("radius", data.radius)
            .data("search-key", data.searchKey);

        $mapDiv.attr("data-locations", data.locations);

        if ($mapDiv.data("has-google-api")) {
            maps();
        } else {
            $(".store-locator-no-apiKey").show();
        }

        if (data.storesResultsHtml) {
            $resultsDiv.append(data.storesResultsHtml);
            $(".store-map-link").on("click", function () {
                var clickStoreNameGtm = {
                    event: "trackEvent",
                    eventCategory: "cta",
                    eventAction: "click en link de sucursal",
                    eventLabel: $(this).prop("innerText"),
                };
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(clickStoreNameGtm);
            });
        }
    } else {
        $(".store-locator-no-results-pickit").removeClass("d-none");
        $resultsDiv.addClass("d-none");
    }
}

/**
 * Search Stores
 * @param {Object} element
 */
function search(element) {
    var $storeLocatorModal = element.closest(".modal");
    $storeLocatorModal.spinner().start();
    var $form = element.closest(".store-locator");
    var url = $form.attr("action");
    var shipmentUUID = $storeLocatorModal.attr("shipmentuuid");

    var payload = {
        postalCode: $form.find('[name="postalCode"]').val(),
        shipmentUUID: shipmentUUID,
    };

    /**
     * DAB-4756  BEGIN Find store with postal code Google Tag Manager
     */
    var storesGtmEvent = {
        event: "trackEvent",
        eventCategory: "cta",
        eventAction: "buscador codigo postal",
        eventLabel: $form.find('[name="postalCode"]').val(),
    };
    if (
        storesGtmEvent.eventLabel !== null &&
        storesGtmEvent.eventLabel !== ""
    ) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(storesGtmEvent);
    }
    /**
     * DAB-4756  END
     */

    $.ajax({
        url: url,
        type: $form.attr("method"),
        data: payload,
        dataType: "json",
        success: function (response) {
            $storeLocatorModal.spinner().stop();
            if (response.error) {
                console.error(response.data);
            } else {
                updateStoresResults(response.data);
                toggleSeeMoreButton();
                $(".select-store-pickit").prop("disabled", true);

                var isCheckout = $('[name="ischeckout"]').length > 0;
                if (isCheckout) {
                    $(".select-store-input-pickit").show();
                    $(".store-details-pickit .result-number").hide();
                }
            }
        },
        error: function (e) {
            $storeLocatorModal.spinner().stop();
            $.spinner().stop();
            console.error("Error in pickIt services", e.responseJSON.data);
        },
    });
    return false;
}

// Sends the store info chosen by the user to the backend and receives the data with the dynamic price by postal code, updating the checkout.
function storeShippingPriceByPostalCode(data) {
    data.shipmentUUID = $('.shipping-form input[name="shipmentUUID"]').val();
    var storeUrl = $("#option-tab-pickIt").find('.selected-store').data('price');
    $('body').trigger('checkout:beforeShippingMethodSelected');
    $.spinner().start();

    $.ajax({
        url: storeUrl,
        method: 'GET',
        dataType: 'json',
        data: data,
        success: function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer
                    }
                );
                $('body').trigger('checkout:shippingMethodSelected', data);
                $.spinner().stop();
            }
        },
        error: function (err) {
            if (err.redirectUrl) {
                window.location.href = err.redirectUrl;
            }
            $.spinner().stop();
        }
    });
}

base.init = function () {
    // Click en Seleccionar Tienda en Modal Pick It
    $("body").on("store:selectedPickIt", function (e, data) {
        var storeLocatorModal = $("#pickItStoresModal");
        var isMulti = storeLocatorModal.attr("ismulti");
        var form;
        if (isMulti) {
            var pliUUIDInput = $(
                "[value=" + storeLocatorModal.attr("productlineitemuuid") + "]"
            );
            form = pliUUIDInput[0].form;
        } else {
            var shipmentSelectorDefualt = $("#shipmentSelector-default");
            form = shipmentSelectorDefualt[0].form;
        }
        var fieldSet = $(".pickup-in-store", form);
        var storeIdInput = fieldSet.find('[name="storeId"]');
        var storeAddressNumber;
        if (data.storeInfo.custom && data.storeInfo.custom.number) {
            storeAddressNumber = data.storeInfo.custom.number;
        } else {
            storeAddressNumber = data.storeInfo.stateCode;
        }
        $(".selected-store", form)
            .find(".store-name")
            .empty()
            .append(data.storeInfo.name);
        $(".selected-store", form)
            .find(".store-map")
            .empty()
            .append(data.storeInfo.address1 + " " + storeAddressNumber);
        $(".selected-store", form).show();
        storeIdInput.val(data.storeID);

        storeShippingPriceByPostalCode(data.storeInfo);
    });

    // Click en Buscar Tienda desde ShippingMethod
    if ($(".open-locator-pick-it")) {
        $(".open-locator-pick-it").on("click", function (e) {
            var postalCodeInput = $(this).siblings("#store-zipCode-pickIt");
            if (postalCodeInput.val() === "") {
                $(this)
                    .closest(".pickit-store-search")
                    .children(".invalid-feedback-store")
                    .text("Coloca un código postal");
                e.stopPropagation();
                return;
            }
            $(this)
                .closest(".pickit-store-search")
                .children(".invalid-feedback-store")
                .text("");

            var storePickItModal = $("#pickItStoresModal");
            var modalPostalCodeInput = storePickItModal.find(
                "#store-pickit-zipCode"
            );
            var modalSearchButton = storePickItModal
                .parent()
                .find(".btn-storelocator-search-pickit");
            var shipmentUUID = postalCodeInput
                .closest(".shipping-form")
                .find('[name="shipmentUUID"]')
                .val();
            if (
                postalCodeInput
                    .closest(".shipping-form")
                    .find('[name="productLineItemUUID"]').length > 0
            ) {
                var pliUUID = postalCodeInput
                    .closest(".shipping-form")
                    .find('[name="productLineItemUUID"]')
                    .val();
                storePickItModal.attr("productLineItemUUID", pliUUID);
                storePickItModal.attr("isMulti", true);
            }
            var originalShipmentUUID = postalCodeInput
                .closest(".shipping-form")
                .find('[name="originalShipmentUUID"]')
                .val();
            modalPostalCodeInput.val(postalCodeInput.val());
            storePickItModal.attr("shipmentUUID", shipmentUUID);
            storePickItModal.attr("originalShipmentUUID", originalShipmentUUID);

            search(modalSearchButton);
        });
    }

    if ($("#map-canvas-pickit").data("has-google-api")) {
        maps();
    } else {
        $(".store-locator-no-apiKey").show();
    }

    if (!$(".results-pickit").data("has-results")) {
        $(".store-locator-no-results-pickit").show();
    }
};

$(".store-locator-container-pickit").on(
    "click",
    ".select-store-pickit",
    function (e) {
        var selectedStore = $(
            ":checked",
            ".results-card-pickit .results-pickit"
        );
        var data = {
            storeID: selectedStore.val(),
            searchRadius: $("#radius").val(),
            searchPostalCode:
                $(".results-pickit").data("search-key").postalCode,
            storeDetailsHtml: selectedStore
                .siblings("label")
                .find(".store-details-pickit")
                .html(),
            storeInfo: JSON.parse(selectedStore.attr("data-store-info")),
            event: e,
        };

        // Mapping Pick It response in Input
        $("#pickItStoresObject").val(JSON.stringify(data));

        /**
         * DAB-4756 BEGIN - push datalayer Select store event Google Tag manager
         */
        var storeSelectedGtmEvent = {
            event: "trackEvent",
            eventCategory: "cta",
            eventAction: `sucursal: ${
                JSON.parse(selectedStore.attr("data-store-info")).name
            }`,
            eventLabel: `Id de sucursal: ${selectedStore.val()}`,
        };
        if (
            selectedStore.attr("data-store-info") !== null &&
            selectedStore.attr("data-store-info") !== ""
        ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(storeSelectedGtmEvent);
        }

        /**
         * DAB-4756 END
         */
        $("button.submit-shipping").attr("disabled", false);
        $("body").trigger("store:selectedPickIt", data);
    }
);

// Available Button Seleccionar when a Store is Selected
$("body").on("change", ".select-store-input-pickit", function () {
    $(".select-store-pickit").prop("disabled", false);
});

// Remove a Store once selected
base.removeSelectedstore = function () {
    $(".selected-store-header i.fa-trash").on("click", function (e) {
        var shipping = {
            UUID: "",
        };
        var form = e.target.form;
        var shipmentUUID = $("input[name=shipmentUUID]", form).val();
        var fieldSet = $(".pickup-in-store", form);
        var selectedStoreHtml = $(".selected-store", form);

        shipping.UUID = shipmentUUID;
        shippingHelpers.methods.updateShippingAddressFormValues(shipping);
        fieldSet.find('[name="storeId"]').val("");
        selectedStoreHtml.find(".store-name").empty();
        selectedStoreHtml.find(".store-map").empty();
        selectedStoreHtml.find(".storelocator-phone").empty();
        selectedStoreHtml.hide();
    });
};

$(".see-all-stores-pickit").on("click", function () {
    if ($(this).hasClass("all-stores-shown")) {
        $(this).removeClass("all-stores-shown");
        if ($(".store-item").hasClass("to-hide")) {
            $(".store-item.to-hide").addClass("d-none");
        }
        $(this).text("Ver todas");
    } else {
        $(this).addClass("all-stores-shown");
        $(".store-item").removeClass("d-none");
        $(this).text("Ver menos");
    }
});

$(
    '.store-locator-container-pickit .btn-storelocator-search-pickit[type="button"]'
).click(function (e) {
    var postalCodeInput = $(this)
        .siblings(".zipCode-modal-container")
        .find(".store-zipCode-pickIt");
    if (postalCodeInput.val() === "") {
        $(this)
            .closest(".search-form-pickit")
            .find(".invalid-feedback-store")
            .text("Coloca un código postal");
        e.stopPropagation();
        return;
    }
    $(this)
        .closest(".search-form-pickit")
        .find(".invalid-feedback-store")
        .text("");
    
    $("#store-zipCode-pickIt").val(postalCodeInput.val());
    search($(this));
});

module.exports = base;
